import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';

@Component({
    selector: 'app-img',
    templateUrl: './img.component.html',
    styleUrls: ['./img.component.css']
})
export class ImgComponent implements OnInit {
    @Input() editData: any; // Assuming editData is an input property
    @Output() imageUpload = new EventEmitter<File>();

    constructor() { }

    ngOnInit(): void {
    }

    clearTmpImg(): void {
        this.editData = '';
    }
    
    upload(event: any, index: string): void {
        const file = event.target.files[0];
        this.imageUpload.emit(file);

        var reader = new FileReader();
        reader.readAsDataURL(file);//读出 base64
        
        reader.onloadend = ((e)=>{
            this.editData = e.target.result;           
        });
    }

}
